import script from "./MessageRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageRow.vue?vue&type=script&setup=true&lang=ts"

import "./MessageRow.vue?vue&type=style&index=0&id=00e93a53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e93a53"]])

export default __exports__